import { generateFirestoreId } from '@/globals/typescript/utils/utils'
import {
  resolvePlaceholdersWith,
  type IResolvePlaceholdersContext,
} from './resolvePlaceholdersCore'

export type { IResolvePlaceholdersContext }

/**
 * Resolves `{{token}}` placeholders in a seed JSON array string — see `resolvePlaceholdersCore.ts` for
 * the token types and the `_seedID` rules. This is the app's entry: IDs come from `generateFirestoreId`.
 */
export function resolvePlaceholders(
  rawJson: string,
  context: IResolvePlaceholdersContext,
  idMap: Record<string, string> = {}
): Record<string, unknown>[] {
  return resolvePlaceholdersWith(generateFirestoreId, rawJson, context, idMap)
}
